import { motion } from "motion/react";
import { CONTACT_INFO } from "@/constants/company";
import logoImg from "@/assets/images/Logo.webp";

interface HeaderProps {
  onNavigate: (sectionId: string) => void;
}

export function Header({ onNavigate }: HeaderProps) {
  const navItems = [
    { label: "Inicio", id: "inicio" },
    { label: "Nosotros", id: "nosotros" },
    { label: "Servicios", id: "servicios" },
    { label: "Catálogo", id: "catálogo" },
    { label: "Contacto", id: "contacto" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50 border-b border-[#A5E0DF]/30">
      <div className="max-w-7xl mx-auto px-6 h-28 flex items-center justify-between">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center cursor-pointer"
          onClick={() => onNavigate("inicio")}
        >
          <img
            src={logoImg}
            alt="NEA Sinergia Proyectos SAC"
            className="h-24 w-auto object-contain"
          />
        </motion.div>

        <motion.nav
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="hidden md:flex items-center gap-8"
        >
          {navItems.map((item) => (
            <motion.button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              whileHover={{ y: -2 }}
              className="relative text-[#0A2540] font-bold text-[15px] hover:text-[#39B5BF] transition-colors group"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#39B5BF] group-hover:w-full transition-all duration-300" />
            </motion.button>
          ))}
        </motion.nav>

        <motion.a
          href={CONTACT_INFO.whatsapp.url}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ scale: 1.05 }}
          className="hidden lg:flex items-center gap-2 bg-[#39B5BF] hover:bg-[#2C9AA4] text-white font-bold text-sm px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all"
        >
          Cotizar Proyecto
        </motion.a>
      </div>
    </header>
  );
}